import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "home" */ '../views/Login')
  },
  {
    path: '/assetslogin',
    name: 'assetslogin',
    component: () => import(/* webpackChunkName: "home" */ '../views/AssetsLogin')
  },
  {
    path: '/ssologin',
    name: 'ssologin',
    component: () => import(/* webpackChunkName: "home" */ '../views/SsoLogin')
  },
  {
    path: '/ssolg',
    name: 'ssolg',
    component: () => import(/* webpackChunkName: "home" */ '../views/SsoLg')
  },
  {
    path: '/qcclogin',
    name: 'qcclogin',
    component: () => import(/* webpackChunkName: "home" */ '../views/QccLogin')
  },
  {
    path: '/queryLogin',
    name: 'queryLogin',
    component: () => import(/* webpackChunkName: "home" */ '../views/QueryLogin')
  },
  {
    path: '/queryIndex',
    name: 'queryIndex',
    component: () => import(/* webpackChunkName: "home" */ '../views/QueryIndex')
  },
  {
    path: '/queryxd',
    name: 'queryxd',
    component: () => import(/* webpackChunkName: "home" */ '../views/QueryXDList.vue')
  },
  {
    path: '/market',
    name: 'Market',
    component: () => import(/* webpackChunkName: "market" */ '../views/Market')
  },
  {
    path: '/selectmm',
    name: 'selectmm',
    component: () => import(/* webpackChunkName: "market" */ '../views/SelectMarketMode')
  },
  {
    path: '/addchannel',
    name: 'addchannel',
    component: () => import(/* webpackChunkName: "market" */ '../views/AddChannel')
  },
  {
    path: '/addmarket',
    name: 'AddMarket',
    component: () => import(/* webpackChunkName: "addmarket" */ '../views/AddMarket')
    // meta: {
    //   keepAlive: true
    // }
  },
  {
    path: '/viewmarket',
    name: 'ViewMarket',
    component: () => import(/* webpackChunkName: "viewmarket" */ '../views/ViewMarket')
  },
  {
    path: '/followup',
    name: 'followup',
    component: () => import(/* webpackChunkName: "followup" */ '../views/Followup')
  },
  {
    path: '/addfollowup',
    name: 'addfollowup',
    component: () => import(/* webpackChunkName: "addfollowup" */ '../views/AddFollowup')
  },
  {
    path: '/marketmap',
    name: 'marketmap',
    component: () => import(/* webpackChunkName: "marketmap" */ '../views/MarketMap')
  },
  {
    path: '/plain',
    name: 'plain',
    component: () => import(/* webpackChunkName: "plain" */ '../views/Plain')
  },
  {
    path: '/addplain',
    name: 'addplain',
    component: () => import(/* webpackChunkName: "addplain" */ '../views/AddPlain')
  },
  {
    path: '/public',
    name: 'public',
    component: () => import(/* webpackChunkName: "public" */ '../views/Public')
  },
  {
    path: '/hismarket',
    name: 'hismarket',
    component: () => import(/* webpackChunkName: "public" */ '../views/Hismarket')
  },
  {
    path: '/draftbox',
    name: 'draftbox',
    component: () => import(/* webpackChunkName: "public" */ '../views/DraftBox')
  },
  {
    path: '/help',
    name: 'help',
    component: () => import(/* webpackChunkName: "public" */ '../views/Help')
  },
  {
    path: '/custompool',
    name: 'custompool',
    component: () => import(/* webpackChunkName: "public" */ '../views/Custompool')
  },
  {
    path: '/pooldetail',
    name: 'pooldetail',
    component: () => import(/* webpackChunkName: "public" */ '../views/Pooldetail')
  },
  {
    path: '/homeassets',
    name: 'homeassets',
    component: () => import(/* webpackChunkName: "public" */ '../views/HomeAssets')
  },
  {
    path: '/addassets',
    name: 'addassets',
    component: () => import(/* webpackChunkName: "public" */ '../views/AddAssets')
  },
  {
    path: '/addcheck',
    name: 'addcheck',
    component: () => import(/* webpackChunkName: "public" */ '../views/AddCheck')
  },
  {
    path: '/hisassets',
    name: 'hisassets',
    component: () => import(/* webpackChunkName: "public" */ '../views/HisAssets')
  },
  {
    path: '/verifylist',
    name: 'verifylist',
    component: () => import(/* webpackChunkName: "public" */ '../views/VerifyAssets')
  },
  {
    path: '/verifydetail',
    name: 'verifydetail',
    component: () => import(/* webpackChunkName: "public" */ '../views/VerifyDetail')
  },
  {
    path: '/qcclist',
    name: 'qcclist',
    component: () => import(/* webpackChunkName: "public" */ '../views/QccList')
  }
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
